import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48ef89e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gridlistausuarios" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card-header ta-c" }
const _hoisted_4 = { class: "bold" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Email: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Rol: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.usuarios, (usuario, index) => {
      return (_openBlock(), _createElementBlock("div", {
        style: {"cursor":"pointer"},
        key: index,
        onClick: ($event: any) => (this.$router.push(`/usuarios/${usuario._id}`)),
        class: "card mb-3"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(usuario.nombre), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _hoisted_6,
            _createTextVNode(_toDisplayString(usuario.email), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_7,
            _createTextVNode(_toDisplayString(usuario.role), 1)
          ])
        ])
      ], 8, _hoisted_2))
    }), 128))
  ]))
}